export const BEURL = process.env.REACT_APP_BEURL;  //back-end URL
export const WSURL = process.env.REACT_APP_WSURL;  //web-scoket URL
export const FEURL = process.env.REACT_APP_FEURL;  //front-end URL
export const S3URL = process.env.REACT_APP_S3URL;  //S3 bucket URL
export const EnterpriseContactUsFormURL = "https://forms.zohopublic.in/walnutsknowledgesolutions/form/ContactUsForLandingPageInternalstakeholdersNewwebs/formperma/5cZhqY6JVbGUUJum1FXhDqD1fGa50DGG5iHccrtQtgg";